export default __webpack_public_path__ + "static/media/in_production.a1db074f.svg";